import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import {
  getTemplateEnvelope
} from "../../../../../services/Templates";
import { toast } from "react-toastify";
import Utils from "../../../../../utils";
import { getEnvelopeSenderList } from "../../../../../services/CommonService";
import {
  NAME_CONVENTION,
  OVERDUE_REMINDER,
  SEND_REMINDER,
  SYNC_STATUS
} from "../../../../../configs/AppConfig";
import { Lang } from "../../../../../lang";
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import RequestForm from "./RequestForm";
import DocumentViewTemplate from "./DocumentViewTemplate";

function ViewTemplateShare(props) {
  const navigate = useNavigate();
  const location = useLocation();

  let { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [allSenders, setAllSenders] = useState([]);
  const [selectedSenders, setSelectedSenders] = useState([]);
  const [envelopeName, setEnvelopeName] = useState('');
  const [clientMessage, setClientMessage] = useState('');
  const [subject, setSubject] = useState('');
  const [emailText, setEmailText] = useState('');
  const [documentList, setDocumentList] = useState([]);
  const [requestFormList, setRequestFormList] = useState([]);
  const [nameConvention, setNameConvention] = useState(1);
  const [cloudSync, setCloudSync] = useState(0);
  const [sendReminder, setSendReminder] = useState(0);
  const [overdueReminder, setOverdueReminder] = useState(0);
  const [isPassword, setIsPassword] = useState(0);
  const [password, setPassword] = useState('');
  const [referenceId, setReferenceId] = useState('');

  const animatedComponents = makeAnimated();


  const originalTabId = location.state?.returnTabId; // Default to Templates tab
  const originalTabName = location.state?.returnTabName;
  const originalFolderId = location.state?.returnFolderId; // Default to root folder
  const originalBreadcrumbs = location.state?.returnBreadcrumbs;

  let docObj = {
    id: 0,
    name: '',
    detail: '',
    files: [],
    date_format: 0,
    remove_doc_id: []
  };
  const [docData, setDocData] = useState(docObj);

  let formObj = {
    id: 0,
    name: '',
    questions: []
  };
  const [formData, setFormData] = useState(formObj);

  useEffect(function () {
    setLoading(true);
    getEnvelopeSenderList()
      .then(responseData => {
        let sList = responseData.data.data;
        let selectedSenderList = [];
        for (let i = 0; i < sList.length; i++) {
          selectedSenderList.push({
            value: parseInt(sList[i]['id']),
            label: sList[i]['first_name'] + ' ' + sList[i]['last_name']
          });
        }
        setAllSenders(selectedSenderList);

        getTemplateEnvelope({ uuid: id })
          .then(response => {
            setBreadcrumbs(response.data.breadcrumbs);
            setEnvelopeName(response.data.data.envelope_name);
            setClientMessage(response.data.data.message);
            setSubject(response.data.data.email_subject);
            setEmailText(response.data.data.email_text);
            setDocumentList(response.data.data.document_list);
            setRequestFormList(response.data.data.request_form_list);
            setNameConvention((response.data.data.name_convention) ? parseInt(response.data.data.name_convention) : 1);
            setCloudSync((response.data.data.cloud_sync) ? parseInt(response.data.data.cloud_sync) : 0);
            setSendReminder((response.data.data.send_reminder) ? parseInt(response.data.data.send_reminder) : 0);
            setOverdueReminder((response.data.data.over_due_reminder) ? parseInt(response.data.data.over_due_reminder) : 0);
            if (response.data.data.password) {
              setIsPassword(1);
              setPassword(response.data.data.password);
            } else {
              setIsPassword(0);
            }
            setReferenceId((response.data.data.reference_id) ? response.data.data.reference_id : '');

            let selectedSList = [];
            if (response.data.data.share_user_ids) {
              for (let i = 0; i < sList.length; i++) {
                let index = response.data.data.share_user_ids.findIndex(x => parseInt(x) === parseInt(sList[i]['id']));
                if (index > -1) {
                  selectedSList.push({
                    value: parseInt(sList[i]['id']),
                    label: sList[i]['first_name'] + ' ' + sList[i]['last_name']
                  });
                }
              }
            }
            setSelectedSenders(selectedSList);
            setLoading(false);
          })
          .catch(err => {
            navigate('/templates');
            toast.error(Utils.getErrorMessage(err));
            setLoading(false);
          });
      })
      .catch(err => {
        setLoading(false);
        navigate('/templates');
        toast.error(Utils.getErrorMessage(err));
      });
  }, [id, navigate, props]);

  const onBackTemplate = (e) => {
    e.preventDefault();
    navigate('/templates', {
      state: {
        originalTabId: originalTabId,
        originalTabName: originalTabName,
        folderId: originalFolderId,
        breadcrumbs: originalBreadcrumbs
      }
    });
  };


  const handleBreadcrumbClick = (e, breadcrumbItem, index) => {
    e.preventDefault();
    e.stopPropagation();

    try {

      // Check for different possible ID field names
      const folderId = breadcrumbItem.id || breadcrumbItem.folder_id || breadcrumbItem.entity_id || breadcrumbItem.folderId;


      // Navigate to templates page with the specific folder ID and breadcrumb data
      if (folderId) {

        // Get the breadcrumbs up to the clicked item (inclusive)
        const breadcrumbsToPass = breadcrumbs.slice(0, index + 1);

        navigate('/templates', {
          state: {
            folderId: folderId,
            breadcrumbs: breadcrumbsToPass, // Pass breadcrumbs up to this point
            fromModifyTemplate: true, // Flag to indicate navigation from ModifyTemplate
            originalTabId: originalTabId,
            originalTabName: originalTabName,
            returnFolderId: originalFolderId,
            returnBreadcrumbs: originalBreadcrumbs
          }
        });

        // Fallback navigation in case state navigation fails
        setTimeout(() => {
          try {
            navigate(`/templates?folder=${folderId}&tab=${originalTabId}&breadcrumbs=${encodeURIComponent(JSON.stringify(breadcrumbsToPass))}`);
          } catch (fallbackError) {
            console.error('Fallback navigation also failed:', fallbackError);
          }
        }, 100);
      } else {
        // If no ID, go to root templates with original tab and folder
        navigate('/templates', {
          state: {
            originalTabId: originalTabId,
            originalTabName: originalTabName,
            folderId: originalFolderId,
            breadcrumbs: originalBreadcrumbs
          }
        });
      }
    } catch (error) {
      console.error('Error navigating to folder:', error);
      // Fallback to root templates with original tab and folder
      navigate('/templates', {
        state: {
          originalTabId: originalTabId,
          originalTabName: originalTabName,
          folderId: originalFolderId,
          breadcrumbs: originalBreadcrumbs
        }
      });
    }
  };

  // New function to handle "Templates" click
  const handleTemplatesClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    navigate('/templates');
  };

  const handleViewDoc = (e, data) => {
    e.preventDefault();
    let obj = {
      id: data.id,
      name: data.name,
      detail: data.detail,
      files: data.files,
      date_format: data.date_format,
      remove_doc_id: data.remove_doc_id
    };
    setDocData(obj);
  };

  const handleViewRequestForm = (e, data) => {
    e.preventDefault();
    let obj = {
      id: data.id,
      name: data.name,
      questions: data.questions
    };
    setFormData(obj);
  };

  const handlePassword = (e) => {
    setIsPassword(e.target.value);
    setPassword('');
  };

  return (
    <>
      {loading && <div className="page-loading">
        <img src="/images/loader.gif" alt="loader" />
      </div>}
      <div className="templates_page">
        <section className="main_wrapper section-bg-color sleeve-gradient-bg" style={{ minHeight: 'calc(100vh - 0px)' }}>
          <div className="container" style={{ marginTop: "8vh" }}>
            <div className="modify-template-title text-white mb-3 d-flex align-items-center justify-content-between bread_crumb flexWrap">
              <h2>Template</h2>
              <div className="d-flex">
                <button type="button" className="modern-back-btn ms-2 d-flex align-items-center"
                  data-toggle="tooltip" data-placement="right" title="Click me to back"
                  onClick={onBackTemplate}>
                  <i className="bi bi-arrow-left me-2"></i>Back
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12 my-3">
                <h2 className="mb-3 bread_crumb flexWrap px-3 text-white">
                  <div className="modify-template-breadcrumb">
                    {breadcrumbs.length === 0 ? (
                      <span className="breadcrumb-link" onClick={handleTemplatesClick}>
                        <i className="bi bi-folder-fill" aria-hidden="true" /> Templates
                      </span>
                    ) : (
                      <>
                        <span
                          className="breadcrumb-link"
                          onClick={handleTemplatesClick}
                          title="Click to go to Templates"
                        >
                          <i className="bi bi-folder-fill" aria-hidden="true" /> Templates
                        </span>
                        {breadcrumbs.map((item, index) => (
                          <React.Fragment key={index}>
                            <span className="breadcrumb-separator">
                              <i className="bi bi-chevron-right" />
                            </span>
                            <span
                              className={item.is_last === true ? "breadcrumb-current" : "breadcrumb-link"}
                              onClick={item.is_last === true ? undefined : (e) => handleBreadcrumbClick(e, item, index)}
                              title={item.is_last === true ? undefined : `Click to go to ${item.folder_name}`}
                            >
                              <i className="bi bi-folder-fill" aria-hidden="true" /> {item.folder_name}
                            </span>
                          </React.Fragment>
                        ))}
                      </>
                    )}
                  </div>
                </h2>
              </div>
            </div>
            <div>

              {/*1. Template Directory */}
              <div className="modify-template-card">
                <h2 className="modify-template-card-title">
                  <span className="round_blue me-2">1</span>Template Directory
                </h2>
                <div className="mb-0">
                  <label className="form-label modify-template-card-label">Share with
                    <i className="bi bi-info-circle ms-1 cur-pointer cursor-pointer" aria-hidden="true"
                      data-toggle="tooltip" data-placement="right"
                      title="Share this template with users" />
                  </label>
                  <Select closeMenuOnSelect={true} value={selectedSenders}
                    components={animatedComponents} isMulti
                    onChange={(e) => setSelectedSenders(e)}
                    options={allSenders} isDisabled={true} />
                </div>
              </div>

              {/* 2. Sleeve Details */}
              <div className="modify-template-card">
                <h2 className="modify-template-card-title">
                  <span className="round_blue me-2">2</span>Sleeve Details
                </h2>
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-4">
                      <label className="form-label modify-template-card-label">Request Title / Folder Name (Sleeve Name)
                        <i className="bi bi-info-circle ms-1 cur-pointer cursor-pointer" aria-hidden="true"
                          data-toggle="tooltip" data-placement="right"
                          title={Lang.env_envelope_name} />
                      </label>
                      <input type="text" className="form-control" value={envelopeName}
                        onChange={(e) => setEnvelopeName(e.target.value)}
                        aria-describedby="emailHelp" readOnly
                        placeholder="Enter Sleeves Name" />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-0">
                      <label className="form-label modify-template-card-label">Client Portal Message
                        <i className="bi bi-info-circle ms-1 cur-pointer cursor-pointer" aria-hidden="true"
                          data-toggle="tooltip" data-placement="right"
                          title={Lang.env_client_message} />
                      </label>
                      <textarea className="form-control" rows={9} value={clientMessage}
                        onChange={(e) => setClientMessage(e.target.value)}
                        readOnly placeholder="Enter Message to Client" />
                    </div>
                  </div>
                </div>
              </div>

              {/* 3. Email Details */}
              <div className="modify-template-card">
                <h2 className="modify-template-card-title">
                  <span className="round_blue me-2">3</span>Email Details
                </h2>
                <div>
                  <div className="mb-4">
                    <label htmlFor="email_subject" className="form-label modify-template-card-label">Subject
                      <i className="bi bi-info-circle ms-1 cur-pointer cursor-pointer" aria-hidden="true"
                        data-toggle="tooltip" data-placement="right"
                        title={Lang.env_subject} />
                    </label>
                    <input type="text" className="form-control" id="email_subject" readOnly
                      value={subject} onChange={(e) => setSubject(e.target.value)}
                      aria-describedby="emailHelp" placeholder="Enter Email Subject" />
                  </div>
                  <div className="mb-4">
                    <label htmlFor="email_text" className="form-label modify-template-card-label">Email Text
                      <i className="bi bi-info-circle ms-1 cur-pointer cursor-pointer" aria-hidden="true"
                        data-toggle="tooltip" data-placement="right"
                        title={Lang.env_email_text} />
                    </label>
                    <textarea className="form-control" rows={12} value={emailText}
                      onChange={(e) => setEmailText(e.target.value)} readOnly
                      placeholder="Enter Email text box" />
                  </div>
                </div>
              </div>

              {/* 4. Document Request */}
              <div className="modify-template-card">
                <h2 className="modify-template-card-title">
                  <span className="round_blue me-2">4</span>Document Request
                </h2>
                <div className="">
                  {documentList.map((item, index) =>
                    <h2 key={index} className="request_document_tab mb-2 cursor-pointer"
                      onClick={(e) => handleViewDoc(e, item)} data-bs-toggle="offcanvas"
                      data-bs-target="#Add-document"
                      aria-controls="Add-document"
                      data-toggle="tooltip"
                      data-placement="right" title="Click to View Document Request"
                    >
                      <div className="d-flex justify-content-between">
                        <div className="accordion_text">
                          <img src="/images/dots_rectangle.webp" alt="..."
                            className="me-3" />
                          {item.name}
                        </div>
                        <div className="functional_icon_ellipsis">
                          {/* <span className="functional_icon_round"
                            data-toggle="tooltip" data-placement="right" title=""
                            data-bs-original-title="click Me">
                            <i className="bi bi-people-fill" aria-hidden="true" />
                          </span> */}
                          <div className="dropdown">
                            {/* <span className="functional_icon_ellipsis cursor-pointer"
                              id="dropdownMenuButton1" data-bs-toggle="dropdown"
                              aria-expanded="false" onClick={e => {
    e.stopPropagation();
  }}>
                              <i className="bi bi-three-dots-vertical" />
                            </span> */}
                            <ul className="dropdown-menu"
                              aria-labelledby="dropdownMenuButton1">
                              <li data-bs-toggle="offcanvas"
                                data-bs-target="#Add-document"
                                aria-controls="Add-document"
                                onClick={(e) => handleViewDoc(e, item)}>
                                <span className="dropdown-item">
                                  <i className="bi bi-eye me-2"
                                    aria-hidden="true" /> View
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </h2>
                  )}
                </div>
              </div>

              {/* 5. Information Request (Form Builder) */}
              {requestFormList.length > 0 && (
                <>
                  <div className="modify-template-card">
                    <h2 className="modify-template-card-title">
                      <span className="round_blue me-2">5</span>Information Request (Form Builder)
                    </h2>
                    <div className="mb-4 mt-4">
                      {requestFormList.map((item, index) =>
                        <h2 key={index} className="request_document_tab yellow mb-2 cursor-pointer"
                          data-bs-target="#MakeForm"
                          data-bs-toggle="offcanvas"
                          aria-controls="MakeForm"
                          onClick={(e) => handleViewRequestForm(e, item)}
                          data-toggle="tooltip"
                          data-placement="right" title="Click to View Information Request">
                          <div className="d-flex justify-content-between">
                            <div className="accordion_text">
                              <img src="/images/dots_rectangle.webp" alt="..."
                                className="me-3" />{item.name}
                            </div>
                            <div className="functional_icon_ellipsis">
                              {/* <span className="functional_icon_round"
                              data-toggle="tooltip" data-placement="right" title=""
                              data-bs-original-title="click Me">
                              <i className="bi bi-people-fill" aria-hidden="true" />
                            </span> */}
                              <div className="dropdown">
                                {/* <span className="functional_icon_ellipsis"
                                  id="dropdownMenuButton1" data-bs-toggle="dropdown"
                                  aria-expanded="false" onClick={e => {
    e.stopPropagation();
  }}>
                                  <i className="bi bi-three-dots-vertical" />
                                </span> */}
                                <ul className="dropdown-menu"
                                  aria-labelledby="dropdownMenuButton1">
                                  <li data-bs-toggle="offcanvas"
                                    data-bs-target="#MakeForm"
                                    aria-controls="MakeForm"
                                    onClick={(e) => handleViewRequestForm(e, item)}>
                                    <span className="dropdown-item">
                                      <i className="bi bi-eye me-2"
                                        aria-hidden="true" /> View
                                    </span>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </h2>
                      )}
                    </div>
                  </div>
                </>
              )}

              <div className="modify-template-card"
                id="accordionMedicare">
                <div className="accordion-item  border-0 ">
                  <h2 className="modify-template-card-title">
                    {/* <button className="modify-template-card-title" type="button"
                      data-bs-toggle="collapse" data-bs-target="#Medicare-Rejected"
                      aria-expanded="true" aria-controls="Medicare-Rejected"> */}
                    <span className="round_blue me-2">6</span>More Settings
                    {/* </button> */}
                  </h2>

                  <div id="Medicare-Rejected"
                    className="accordion-collapse collapse show"
                    aria-labelledby="MedicareRejected" data-bs-parent="#accordionMedicare">
                    <div className="">
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="mb-0">
                            <label className="form-label modify-template-card-label">Naming
                              Convention</label>
                            <div className="d-flex align-items-center">
                              <select className="form-select" disabled
                                value={nameConvention}
                                onChange={(e) => setNameConvention(e.target.value)}>
                                {NAME_CONVENTION.map((item, index) =>
                                  <option key={index}
                                    value={item.id}>{item.value}</option>
                                )}
                              </select>
                              <i className="bi bi-info-circle ms-1 cur-pointer cursor-pointer"
                                aria-hidden="true" data-toggle="tooltip"
                                data-placement="right"
                                title={Lang.env_naming_convention} />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="mb-4 ">
                            <label className="form-label modify-template-card-label">Cloud Storage
                              Sync</label>
                            <div className="d-flex align-items-center">
                              <select className="form-select" value={cloudSync}
                                onChange={(e) => setCloudSync(e.target.value)}
                                disabled>
                                {SYNC_STATUS.map((item, index) =>
                                  <option key={index}
                                    value={item.id}>{item.value}</option>
                                )}
                              </select>
                              <i className="bi bi-info-circle ms-1 cur-pointer cursor-pointer"
                                aria-hidden="true" data-toggle="tooltip"
                                data-placement="right"
                                title={Lang.env_cloud_sync} />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="mb-4 ">
                            <label className="form-label modify-template-card-label">Send Reminder
                              (Email)</label>
                            <div className="d-flex align-items-center">
                              <select className="form-select" value={sendReminder}
                                onChange={(e) => setSendReminder(e.target.value)}
                                disabled>
                                {SEND_REMINDER.map((item, index) =>
                                  <option key={index}
                                    value={item.id}>{item.value}</option>
                                )}
                              </select>
                              <i className="bi bi-info-circle ms-1 cur-pointer cursor-pointer"
                                aria-hidden="true" data-toggle="tooltip"
                                data-placement="right"
                                title={Lang.env_send_reminder} />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="mb-4 ">
                            <label className="form-label modify-template-card-label">Overdue
                              Reminder (Email)</label>
                            <div className="d-flex align-items-center">
                              <select className="form-select"
                                value={overdueReminder}
                                onChange={(e) => setOverdueReminder(e.target.value)}
                                disabled>
                                {OVERDUE_REMINDER.map((item, index) =>
                                  <option key={index}
                                    value={item.id}>{item.value}</option>
                                )}
                              </select>
                              <i className="bi bi-info-circle ms-1 cur-pointer cursor-pointer"
                                aria-hidden="true" data-toggle="tooltip"
                                data-placement="right"
                                title={Lang.env_overdue_reminder} />
                            </div>
                          </div>
                        </div>
                        {/* <div className="col-lg-6">
                          <div className="mb-4 ">
                            <label className="form-label modify-template-card-label">Password
                              Protected</label>
                            <div className="d-flex align-items-center">
                              <select className="form-select" value={isPassword}
                                onChange={handlePassword} disabled
                                aria-label="Default select example">
                                {PASSWORD_LIST.map((item, index) =>
                                  <option key={index}
                                    value={item.id}>{item.value}</option>
                                )}
                              </select>
                              <i className="bi bi-info-circle ms-1 cur-pointer cursor-pointer"
                                aria-hidden="true" data-toggle="tooltip"
                                data-placement="right"
                                title={Lang.env_password} />
                            </div>
                          </div>
                        </div> */}
                        {/* {isPassword > 0 && (
                          <div className="col-lg-6">
                            <div className="mb-0">
                              <label className="form-label modify-template-card-label">Password</label>
                              <div className="d-flex align-items-center">
                                <input type="password" value={password}
                                  onChange={(e) => setPassword(e.target.value)}
                                  className="form-control"
                                  placeholder="Enter password" />
                                <i className="bi bi-info-circle ms-1 cur-pointer cursor-pointer"
                                  aria-hidden="true" data-toggle="tooltip"
                                  data-placement="right"
                                  title={Lang.env_password} />
                              </div>
                            </div>
                          </div>
                        )} */}
                        <div className="col-lg-12">
                          <div className="mb-0 ">
                            <label className="form-label modify-template-card-label">Reference
                              ID</label>
                            <div className="d-flex align-items-center">
                              <input type="text" value={referenceId}
                                onChange={(e) => setReferenceId(e.target.value)}
                                className="form-control" readOnly
                                placeholder="Enter Reference ID" />
                              <i className="bi bi-info-circle ms-1 cur-pointer cursor-pointer"
                                aria-hidden="true" data-toggle="tooltip"
                                data-placement="right"
                                title={Lang.env_reference} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <DocumentViewTemplate docData={docData} setDocData={setDocData} documentList={documentList}
        setDocumentList={setDocumentList} />

      <RequestForm formData={formData} setFormData={setFormData} requestFormList={requestFormList}
        setRequestFormList={setRequestFormList} />
    </>
  );
}

export default ViewTemplateShare;